import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import Loading from "../../components/Loading/Loading";
import { PromotionsStatus } from "../orderBuilder/store/constants";
import { useParams } from "react-router-dom";
import { format } from "date-fns";

import(/* webpackChunkName: "promotions" */ "./promotions.scss");

const Promotions = ({
  loadPromotions,
  profileData,
  promotionsData,
  promotionsStatus,
}) => {
  const { promotionId } = useParams();
  useEffect(() => {
    if (loadPromotions) {
      loadPromotions();
    }
  }, [loadPromotions]);

  if (promotionsStatus === PromotionsStatus.LOADING) {
    return <Loading />;
  }

  const organisationPromotions = (promotionsData || []).filter(
    (promotion) =>
      profileData &&
      Number(promotion.OrganisationCode) === Number(profileData.OrganisationCode) &&
      (!promotionId || promotion.PromotionId === Number(promotionId))
  );

  if (promotionId && organisationPromotions.length === 1) {
    const promotion = organisationPromotions[0];

    return (
      <div className="promotions-page promotion-details-page">
        <p className="promotion-label">Promotion</p>
        <h1>{promotion.PromotionName}</h1>
        <p className="promotion-end-date">
          Promotion Ends: {format(new Date(promotion.EndDate), "do MMMM yyyy")}
        </p>
        <p>See the options available below for this promotion.</p>

        <div className="promotion-detail-offers">
          {(promotion.PromotionOffers || []).map((offer) => {
            const requiredModels = (offer.PromotionOfferItems || [])
              .map((item) => item.ModelTypeCode)
              .filter((code, index, codes) => code && codes.indexOf(code) === index);

            return (
              <section
                className="promotion-detail-offer"
                key={offer.PromotionOfferId}
              >
                <h2>{offer.OfferDescription}</h2>
                {requiredModels.length > 0 && (
                  <p>
                    <strong>Applies to these models:</strong> {requiredModels.join(", ")}
                  </p>
                )}
              </section>
            );
          })}
        </div>
        {promotion.TermsAndConditions && (
          <section className="promotion-terms-and-conditions">
            <h2>Terms and Conditions</h2>
            <p>{promotion.TermsAndConditions}</p>
          </section>
        )}
      </div>
    );
  }

  return (
    <div className="promotions-page">
      <h1>
        {promotionId && organisationPromotions.length === 1
          ? organisationPromotions[0].PromotionName
          : "Promotions"}
      </h1>
      <p className="promotions-introduction">
        View our current promotions and the items required to qualify for each
        offer.
      </p>

      {promotionsStatus === PromotionsStatus.ERROR && (
        <p>Promotions could not be loaded. Please try again later.</p>
      )}

      {promotionsStatus !== PromotionsStatus.ERROR &&
        organisationPromotions.length === 0 && (
          <p>There are no active promotions at this time.</p>
        )}

      {organisationPromotions.map((promotion) => (
          <section
            className="promotion-card"
            key={promotion.PromotionId}
          >
            <h2>{promotion.PromotionName}</h2>
            {(promotion.PromotionOffers || []).map((offer) => (
              <div
                className="promotion-offer"
                key={offer.PromotionOfferId}
              >
                <h3>{offer.OfferDescription}</h3>
                <Table responsive className="promotion-items-table">
                  <thead>
                    <tr>
                      <th>Item required</th>
                      <th>Minimum quantity</th>
                      <th>Accessory required</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(offer.PromotionOfferItems || []).map((item) => (
                      <tr key={item.PromotionOfferItemId}>
                        <td>{item.ItemCode}</td>
                        <td>{item.MinQuantity || 1}</td>
                        <td>{item.AccessoryItemCode || "None"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ))}
          </section>
        ))}
    </div>
  );
};

Promotions.propTypes = {
  loadPromotions: PropTypes.func,
  profileData: PropTypes.object,
  promotionsData: PropTypes.array,
  promotionsStatus: PropTypes.string,
};

export default Promotions;
